// extracted by mini-css-extract-plugin
export default {"checkbox":"call-button-settings_checkbox__mzbo6","save":"call-button-settings_save__cxZcW","form":"call-button-settings_form__NZagt"};